import React from 'react';
import content from '../config/content';
import Logo from './Logo';
import Hero from './Hero';
import ElevatorPitch from './ElevatorPitch';
import ContentGrid from './ContentGrid';
import Image from './Image';
import Quote from './Quote';
import Footer from './Footer';

import wellPopup from '../assets/images/well_popup.png';
import overview from '../assets/images/overview.png';
import filter from '../assets/images/filter.png';

const App = () => {
  return (
    [
      <Logo key={"logo"} />,
      <Hero key={"hero"} />,
      <ElevatorPitch key={"elevator"} />,
      <ContentGrid key={"contentgrid-1"} content={content.contentModules.oversight} />,
      <Image key={"image-1"} image={wellPopup} alt="Well popup" />,
      <ContentGrid key={"contentgrid-2"} content={content.contentModules.seek_and_find} />,
      <Image key={"image-2"} offset={1} image={filter} alt="Filtering" />,
      <Quote key={"quote"} />,
      <ContentGrid key={"contentgrid-3"} content={content.contentModules.stakeholders} />,
      <ContentGrid key={"contentgrid-4"} offset={1} content={content.contentModules.planning} />,
      <Image key={"image-3"} image={overview} alt="Overview" />,
      <ContentGrid key={"contentgrid-5"} content={content.contentModules.integrations} />,
      <Footer key={"footer"} />,
    ]
  );
};


export default App;



// WEBPACK FOOTER //
// ./src/components/App.js